import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IStoreModel } from '~/store/types';
import getAccessibleTeamIdsForClinic from '../getAccessibleTeamIdsForClinic';
import { IActTeamActions, IThunkGetActTeamsAvailable } from '../types';
import { IUserRole } from '~/types';

const onGetActTeamsAvailable: IThunkGetActTeamsAvailable = thunk(
  async ({ setAvailableActTeams }: Actions<IActTeamActions>, payload, { getStoreState }) => {
    const { clinicId, isGetAllTeams = false } = payload;
    const store = getStoreState() as IStoreModel;
    const { current } = store.user;

    const currentRole = current?.roles?.find(
      role => role.id === current.roleId && role.clinic?.id === Number(clinicId),
    );
    const isLocalAdmin = currentRole?.name === IUserRole.LocalAdmin;
    const teamIdsInClinic = getAccessibleTeamIdsForClinic(current, clinicId, currentRole);

    const { data } = await api.actTeam.getActTeamsAvailable(clinicId);

    setAvailableActTeams(
      isGetAllTeams || isLocalAdmin ? data : data.filter(team => teamIdsInClinic.includes(team.id)),
    );
  },
);

export default onGetActTeamsAvailable;
